import React, { useEffect } from 'react';
import useIsFeatureEnabled from 'src/presentation/hooks/useIsFeatureEnabled';

const loadGladlySupportChat = () => {
  // Check if script is already loaded
  if (document.querySelector('script[data-gladly-support]')) {
    return;
  }

  const script = document.createElement('script');
  script.setAttribute('data-gladly-support', 'true');
  script.innerHTML = `
    !function(c,n,r,t){if(!c[r]){var i,d,p=[];d="PROD"!==t&&t?"STAGING"===t?"https://cdn.gladly.qa/gladly/chat-sdk/widget.js":t:"https://cdn.gladly.com/chat-sdk/widget.js",c[r]={init:function(){i=arguments;var e={then:function(t){return p.push({type:"t",next:t}),e},catch:function(t){return p.push({type:"c",next:t}),e}};return e}},c.__onHelpAppHostReady__=function(t){if(delete c.__onHelpAppHostReady__,(c[r]=t).loaderCdn=d,i)for(var e=t.init.apply(t,i),n=0;n<p.length;n++){var a=p[n];e="t"===a.type?e.then(a.next):e.catch(a.next)}},function(){try{var t=n.getElementsByTagName("script")[0],e=n.createElement("script");e.async=!0,e.src=d+"?q="+(new Date).getTime(),t.parentNode.insertBefore(e,t)}catch(t){}}()}}
    (window,document,'GladlySupport','PROD')

    if (window.GladlySupport) {
      GladlySupport.init({ appId: "gladlyongladly.com-help" }).catch((error) => {
        console.error('Error initializing GladlySupport', error);
      });
    }
  `;
  document.head.appendChild(script);
};

const GladlySupportChat: React.FC = () => {
  const isFeatureEnabled = useIsFeatureEnabled();

  useEffect(() => {
    if (isFeatureEnabled('gladlySupportChat')) {
      loadGladlySupportChat();
    }
  }, [isFeatureEnabled]);

  // This component doesn't render anything visible
  return null;
};

export default GladlySupportChat;
